export let firebaseConfig = {
  apiKey: "AIzaSyDWdMbQNWcuXUSPSXf3gpGnrL57M5GGu1k",
  authDomain: "djumo-website.firebaseapp.com",
  projectId: "djumo-website",
  storageBucket: "djumo-website.appspot.com",
  messagingSenderId: "610990570382",
  appId: "1:610990570382:web:dfc3c6a462413e1aab42df",
  measurementId: "G-QX0GBC0YPD"
};